module.exports = __webpack_public_path__ + "images/emoji/sushi.f8443216baa71443f1e5.png";